import { createFileRoute } from '@tanstack/react-router';

import { PmpScreen } from '../../features/personal/PmpScreen';

/**
 * `/personal/pmp` = نظام مذاكرة PMP داخل فلو (أمر المالك 2026-08-06).
 *
 * ولا كود من PMP هنا: الشاشة إطارٌ على `/pmp` يخدمه Caddy، فيبقى PMP نظامًا
 * مستقلًّا وتجمعهما الواجهة وحدها — نفس ترتيب رادار.
 */
export const Route = createFileRoute('/personal/pmp')({ component: PmpScreen });
